<template>
    <div>
        <a
            class="btn btn-md is-ghost cursor-pointer flex"
            @click="$modal.show('import-addresses')"
        >
            Importera adresser
        </a>
        <adaptive-form-modal
            name="import-addresses"
            primary-button-text="Starta import"
            primary-button-class="is-primary"
            title="Importera adresser"
            :redirect-to="redirectRoute"
            :action="actionRoute"
        >
            <div>
                <div class="mb-xl p-xl bg-neutral-lightest text-sm">
                    <p>Observera att filen behöver ha formatet .xslx och innehålla korrekta tabellnamn.</p>
                    <p>Om filen innehåller adresser för lägenheter <i>måste</i> lägenhetsnummer finnas med!</p>
                    <a href="/templates/imports/addresses.xlsx" download>Ladda ned exempelfil.</a>
                </div>

                <input
                    id="file"
                    type="file"
                    name="file"
                    class="hidden"
                    @change="fileSelected"
                >
                <label class="btn is-primary cursor-pointer" for="file">
                    Välj fil
                </label>

                <span class="ml-md text-sm">
                    <span v-if="file">
                        Fil har valts
                    </span>
                    <span v-else>
                        Ingen fil har valts
                    </span>
                </span>
                <div class="form-group mt-xl">
                    <p>
                        Alla adresser i Bob behöver tillhöra ett säljprojekt, välj vilket säljprojekt som dessa adresser ska tillhöra.
                    </p>
                    <label
                        for="sales_project_id"
                        class="font-semibold"
                    >
                        Säljprojekt
                    </label>
                    <select
                        id="sales_project_id"
                        required
                        class="form-input"
                        name="sales_project_id"
                    >
                        <option
                            v-for="(id, name) in salesProjects"
                            :value="id"
                        >
                            {{ name }}
                        </option>
                    </select>
                </div>
            </div>
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            deliveryProject: {
                type: Object,
                required: true,
            },
            salesProjects: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                file: null,
            };
        },
        computed: {
            actionRoute() {
                return route('api.delivery-projects.import-addresses.index', { deliveryProject: this.deliveryProject });
            },
            redirectRoute() {
                return window.location.href;
            },
        },
        methods: {
            fileSelected(e) {
                this.file = e.target.value;
            },
        },
    };
</script>
